// extracted by mini-css-extract-plugin
export default {"bg":"x9yVvX","scotchL":"lWaLBd","scotchR":"wHP3g0"};